module.exports = __webpack_public_path__ + "static/media/fscogroup.50c07a47.png";